import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Touch your device to a nfc reader to get started.
        </p>
      </header>
    </div>
  );
}

export default App;
